export default {
  id: null,
  version: null,
  activePackage: null,
  leaveIntention: false,
  contactIntention: false,
  status: null,
  hasScroll: null,
  external: false,
  package: null,
  prePackage: null,
  trackingPackage: null,
  availableNumbers: [],
  settingsName: null,
  isFrameVisible: false,
  frameUrl: '',
  authed: false,
  authToken: null,
  salesGateway: null,
  mode: '',
  referral: null,
  editable: true,
  isBundle: null,
  isInfoVisible: null
};



// WEBPACK FOOTER //
// ./src/store/modules/simulation/state.js